import React, { useEffect, useState } from 'react';
import './sec-booking.css'
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import AddCTA from '../component/common/addcta';
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic28 from '../assets/pic28.png'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic32 from '../assets/pic32.png'
import { supabase } from '../supabase';
import Input from '../component/common/input';
import pic34 from '../assets/pic34.png'
import pic35 from '../assets/pic35.png'
import pic27 from '../assets/pic27.png'
import './sec-support.css'


const Supportmangement = () => {


const [Users, setUsers] = useState([]);
const [showForm, setShowForm] = useState(false);
const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);
const [isEditing, setIsEditing] = useState(false);
const [editingId, setEditingId] = useState(null);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [sort, setSort] = useState('');
const [messages, setMessages] = useState([]);

const [formData, setFormData] = useState({
  user_Id: '',
  title: '',
  title_ar: '',
  message: '',
  message_ar: '',
  Resolved_status: false,
  date: ''
});











useEffect(() => {
  const getMessages = async () => {
    const { data, error } = await supabase
      .from('support_messages')
      .select(`
        *,
        Users:user_Id (
          user_name,
            user_name_ar,
          user_email
        )
      `);

    if (error) {
      console.log("FETCH ERROR:", error);
      return;
    }

    setMessages(data || []);
    console.log(data);
  };

  getMessages();


  const getUsers = async () => {
    const { data } = await supabase
      .from('Users')
      .select('id, user_name, user_email');

    setUsers(data || []);
  };

  getUsers();





}, []);











const filteredMessages = messages
  .filter((item) => {
    const matchesSearch =
      (item.title?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.message?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.Users?.user_name?.toLowerCase() || '').includes(search.toLowerCase());

    let matchesFilter = true;

    if (filter === 'resolved') {
    matchesFilter = item.Resolved_status === true;
    } else if (filter === 'unresolved') {
    matchesFilter = item.Resolved_status === false;
    }

    return matchesSearch && matchesFilter;
  })
    .sort((a, b) => {
    if (sort === 'newest') return new Date(b.date) - new Date(a.date);
    if (sort === 'oldest') return new Date(a.date) - new Date(b.date);
    return 0;
    });

    
    





const handleClose = () => {
  setShowForm(false);
  setIsEditing(false);
  setEditingId(null);

  setFormData({
    user_Id: '',
    title: '',
    title_ar: '',
    message: '',
    message_ar: '',
    Resolved_status: false,
    date: ''
  });
};

const createMessage = async () => {
  const { data, error } = await supabase
    .from('support_messages')
    .insert([formData])
    .select(`
      *,
      Users:user_Id (user_name, user_email)
    `);

  if (error) {
    console.log("CREATE ERROR:", error);
    return;
  }

  setMessages(prev => [...prev, ...data]);
  handleClose();
};









const confirmDelete = async () => {
//   const id = selectedDeleteId;
  await supabase.from('support_messages').delete().eq('id', selectedDeleteId);
  setMessages(prev => prev.filter(m => m.id !== selectedDeleteId));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};






const handleEditClick = (item) => {
  setFormData({
    user_Id: item.user_Id,
    title: item.title,
    title_ar: item.title_ar,
    message: item.message,
    message_ar: item.message_ar,
    Resolved_status: item.Resolved_status,
    date: item.date
  });

  setEditingId(item.id);
  setIsEditing(true);
  setShowForm(true);
};



const updateMessage = async () => {
  const { data, error } = await supabase
    .from('support_messages')
    .update(formData)
    .eq('id', editingId)
    .select(`
      *,
      Users:user_Id (user_name, user_email)
    `);

  if (error) {
    console.log("UPDATE ERROR:", error);
    return;
  }

  setMessages(prev =>
    prev.map(m => (m.id === editingId ? data[0] : m))
  );

  handleClose();
};

const STATUS_MAP_AR = {
  true: 'تم الحل',
  false: 'غير محلول'
};




    return ( 
 <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Support Messages"  
                            para="Manage customer support inquiries"
                            />
                          <AddCTA    title='Add Message'   onClick={() => setShowForm(true)} />
                        
                        </article>



{showForm && (
  <div className="overlay-create">
    <div className="container-create">

      <div className="header-create">
            <h1 className="title-create">
            {isEditing ? 'Edit Message' : 'Add New Message'}
            </h1>

        <button
          className="close-btn-create"
          onClick={handleClose}
          type="button"
        >
          <img src={pic34} alt='close' />
        </button>
      </div>




      <form className="form-create"  onSubmit={(e) => {
            e.preventDefault();
            isEditing ? updateMessage() : createMessage();
            }}>

                                <fieldset className="fieldset">
                                <label className='title-input'>User</label>
                                <div className="select-wrapper2">
                                    <img src={pic28} className="arrow-icon2" alt="arrow" />
                                    <select
                                        className="input-search2 select-style2"
                                        value={formData.user_Id}
                                        onChange={(e) =>
                                        setFormData({ ...formData, user_Id: e.target.value })
                                        }
                                    >
                                        <option value="">Select user</option>
                                        {Users.map((user) => (
                                        <option key={user.id} value={user.id}>
                                            {user.user_name} ({user.user_email})
                                        </option>
                                        ))}
                                    </select>
                                </div>
                            </fieldset>

                            <fieldset className="field-group-create">
                                <Input
                                title="Title (English)"
                                placeholder="Enter title"
                                type="text"
                                value={formData.title}
                                onChange={(e) =>
                                    setFormData({ ...formData, title: e.target.value })
                                }
                                />
                            </fieldset>

                                <fieldset className="field-group-create">
                                        <Input
                                        title="Title (Arabic)"
                                        placeholder="Enter Arabic title"
                                        type="text"
                                        value={formData.title_ar}
                                        onChange={(e) =>
                                            setFormData({ ...formData, title_ar: e.target.value })
                                        }
                                        />
                                </fieldset>

                            <fieldset className="field-group-create">
                                <fieldset className='container-text-area'>
                                <h2 className="title-selecttt">Message (English)</h2>
                                     <textarea
                                    className="main-text-area"
                                    placeholder="Enter message"
                                    value={formData.message}
                                    onChange={(e) =>
                                    setFormData({ ...formData, message: e.target.value })
                                    }
                                    />
                                </fieldset>
                            </fieldset>

                            <fieldset className="field-group-create">
                                <fieldset className='container-text-area'>
                                <h2 className="title-selecttt">Message (Arabic)</h2>
                                <textarea
                                    className="main-text-area"
                                    placeholder="Enter Arabic message"
                                    value={formData.message_ar}
                                    onChange={(e) =>
                                    setFormData({ ...formData, message_ar: e.target.value })
                                    }
                                />
                                </fieldset>
                            </fieldset>

                                <fieldset className="fieldset">
                                    <label className='title-input'>Status</label>
                                    <div className="select-wrapper2">
                                    <img src={pic28} className="arrow-icon2" alt="arrow" />
                                    <select
                                        className="input-search2 select-style2"
                                        value={formData.Resolved_status}
                                        onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            Resolved_status: e.target.value === 'true'
                                        })
                                        }
                                    >
                                        <option value="false">Unresolved</option>
                                        <option value="true">Resolved</option>
                                    </select>
                                    </div>
                                </fieldset>

                            <fieldset className="field-group-create">
                                <Input
                                title="Date"
                                type="date"
                                value={formData.date}
                                onChange={(e) =>
                                    setFormData({ ...formData, date: e.target.value })
                                }
                                />
                            </fieldset>
                            
                                                        <nav className='container-ctas-craete'>
                                                                                    <button   type="button" className="cta-cancel-create" onClick={handleClose}>
                                                                                        <h2 className="cta-cancel-text-create">
                                                                                            Cancel
                                                                                        </h2>
                                                                                    </button>
                                                    
                                                                                    <button type="submit" className='cta-create'>
                                                                                    <h2 className='cta-create-text'>
                                                                                        {isEditing ? 'Edit Message' : 'Add New Message'}
                                                                                    </h2>
                                                                                    </button>
                                                        </nav>
                                

      </form>
    </div>
  </div>
)}






{showDeleteModal && (
  <section className="delete-modal-overlay">
    <article className="delete-modal" role="dialog" aria-modal="true">
      
      <header className="delete-modal-header">
        <div className="delete-icon-wrapper">
          <img src={pic35} alt='icon'></img>
        </div>

        <div className="delete-text-container">
          <h2 className="delete-title">Delete Message</h2>
          <p className="delete-description">
             Are you sure you want to delete this Message? This action cannot be undone.
          </p>
        </div>
      </header>

      <nav className="delete-modal-actions">
        <button
          className="delete-btn-cancel"
          onClick={() => {
            setShowDeleteModal(false);
            setSelectedDeleteId(null);
          }}
        >
          Cancel
        </button>

        <button
          className="delete-btn-confirm"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </nav>

    </article>
  </section>
)}






                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search for user..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />
                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                      <option value="">Filter by</option>

                                    <option value="resolved">Resolved</option>
                                    <option value="unresolved">Unresolved</option>
                                </select>
                                </div>


                                <div className="select-wrapper">
                                       <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic27} className="select-icon" alt="sort" />
                                    <select
                                    className="input-search select-style"
                                    value={sort}
                                    onChange={(e) => setSort(e.target.value)}
                                    >
                                    <option value="">Sort by</option>
                                     <option value="newest">Sort by date (Nearly upcoming)</option>
                                    <option value="oldest">Sort by date (Long-term)</option>
                                    </select>
                                </div>


                            </fieldset>



                                                 <div className="table-container" >
                                <table className='table-support'>
                                    
 {filteredMessages.map((item) => { return <tbody key={item.id}>

                                  <tr className='row-table2-support'>
                                            <tr className='row-table-support'>
   
                                                <td className='first-part-table-support'>

                                                    <td className='first-row-support'>
                                                    <td className='custom-checkbox2'>
                                                                <label className="custom-checkboxxx ">
                                                                <input type="checkbox" />
                                                                <span className="checkmark2"></span>
                                                                </label>
                                                            </td>
                                                    
                                                    <h2 className='support-id'> {item.id}</h2>
                                                    </td>

                                                    <article className='row-1-support'>
                                                        <h2 className='header-support'> {item.title}</h2>
                                                         <td >

                                                            <div className={`status-badge ${item.Resolved_status ? 'resolved' : 'unresolved'}`}>
                                                                <h3 className='text-resolved'>
                                                                {item.Resolved_status ? 'Resolved' : 'Unresolved'}
                                                                </h3>
                                                            </div>
                                                        </td>
                                                    </article>

                                                    <h3 className='sentfrom-support'>From: {item.Users?.user_name} ({item.Users?.user_email})</h3>

                                                    <p className='para-support'>{item.message}</p>
                                                    
                                                </td>

                                                <td className='right-box-about'>
                                                       
                                                            <nav className='cta-table'>
                                                                    <button className='cta2-table'>
                                                                        <img src={pic30} alt='hide'></img>
                                                                    </button>
                                                                    <button
                                                                    className='cta2-table'
                                                                    onClick={() => handleEditClick(item)}
                                                                    >
                                                                    <img src={pic31} alt='edit' />
                                                                    </button>
                                                                    <button
                                                                    className='cta2-table'
                                                                    onClick={() => {
                                                                        setSelectedDeleteId(item.id);
                                                                        setShowDeleteModal(true);
                                                                    }}
                                                                    >
                                                                    <img src={pic32} alt='delete' />
                                                                    </button>
                                                                    
                                                            </nav>
                                                    


                                                        <h3 className='date-support'>{item.date}</h3>
                                                </td>
                                            </tr>

                                            <div className='line-supporttt'></div>

                                                <td className='sec-part-table-support'>



                                                    <article className='row-1-support-ar'>
                                                        <h2 className='header-support-ar'> {item.title_ar}</h2>
                                                         <td >

                                                            <div className={`status-badge ${item.Resolved_status ? 'resolved' : 'unresolved'}`}>
                                                                <h3 className='text-resolved_ar'>
                                                                {STATUS_MAP_AR[item.Resolved_status]}
                                                                </h3>
                                                            </div>
                                                        </td>
                                                    </article>

                                                <h3 className='sentfrom-support-ar'>
                                                ({item.Users?.user_email}) من: {item.Users?.user_name_ar || item.Users?.user_name} 
                                                </h3>

                                                    <p className='para-support-ar'>{item.message_ar}</p>
                                                    
                                                </td>



                                            </tr>





                                    </tbody>
               })}
                                </table>
                                </div>

                                       




                        </section>







                    </section>

            </section>
        </section>
     );
}
 
export default Supportmangement;